// "Untagged" is a virtual tag (id -1) that is not stored: a unit is untagged when it has no tags.
// The unit's `tags` never contain it; the Tags tab shows it checked while the selection is empty (P3-53520).
export const UNTAGGED_TAG_ID = -1;
export const UNTAGGED_TAG = { id: UNTAGGED_TAG_ID, label: "untagged", name: "Tag" };

const isUntagged = (tag) => tag?.id === UNTAGGED_TAG_ID;

// Selection shown in the picker for the unit's real tags.
export const toDisplayedTags = (tags) => (tags?.length ? tags : [UNTAGGED_TAG]);

// Unit tags to keep after the picker reports `values`. Checking "Untagged" clears every real tag;
// checking a real tag while "Untagged" is shown replaces it; unchecking "Untagged" keeps the unit untagged.
export const toUnitTags = (displayedTags, values) => {
  const wasUntagged = displayedTags?.some(isUntagged);
  const nowUntagged = values?.some(isUntagged);

  if (nowUntagged && !wasUntagged) return [];

  return (values || []).filter((tag) => !isUntagged(tag));
};
